import { useId, useRef } from 'react';
import { Button, Modal } from '@shared/components';
import type { QuoteData } from '../types/quote.types';
import { RELOAD_FAILED_MESSAGE, reloadQuoteCopy } from '../utils/reloadQuoteCopy';

export interface ReloadQuoteModalProps {
    isOpen: boolean;
    quoteStatus: QuoteData['status'];
    failed: boolean;
    onReload: () => void;
}

const ignoreDismiss = (): void => undefined;

export const ReloadQuoteModal: React.FC<ReloadQuoteModalProps> = ({
    isOpen,
    quoteStatus,
    failed,
    onReload,
}) => {
    const headingId = useId();
    const reloadButtonRef = useRef<HTMLButtonElement>(null);
    const { title, message } = reloadQuoteCopy(quoteStatus);

    return (
        <Modal
            isOpen={isOpen}
            onClose={ignoreDismiss}
            showCloseButton={false}
            closeOnBackdropClick={false}
            ariaLabelledBy={headingId}
            className="max-w-md p-6"
            initialFocusRef={reloadButtonRef}
        >
            <h2 id={headingId} className="text-lg font-semibold mb-2">
                {title}
            </h2>
            <p className="text-sm text-mp-muted mb-4">{message}</p>
            {failed && (
                <p role="alert" className="text-sm text-mp-error mb-4">
                    {RELOAD_FAILED_MESSAGE}
                </p>
            )}
            <div className="flex justify-end">
                <Button
                    ref={reloadButtonRef}
                    type="button"
                    variant="primary"
                    appearance="solid"
                    onClick={onReload}
                >
                    Reload quote
                </Button>
            </div>
        </Modal>
    );
};
